import { FormField, InputSelectField } from '@tempmee/react';
import { forwardRef, memo, type ReactNode, type Ref, useMemo } from 'react';
import { factoryTimeOptions } from '~/commonComponents/InputJob/Hours/Utils';

interface IDepartureTimeFieldProps {
  value?: string;
  onChange?: (value: string) => void;
  labelRight?: ReactNode;
  hasError?: boolean;
}

const Component = (
  { value, onChange, labelRight, hasError }: IDepartureTimeFieldProps,
  ref: Ref<HTMLDivElement>,
) => {
  const options = useMemo(
    () => factoryTimeOptions().map((o) => ({ label: o.title, value: o.value })),
    [],
  );

  return (
    <div ref={ref} data-testid="departure-time-field" data-cy="departure-time-field">
      <FormField label="Departure" TrailingComponent={labelRight}>
        <InputSelectField<string>
          options={options}
          value={value}
          onChange={onChange}
          placeholder="Select Time"
          isError={Boolean(hasError)}
        />
      </FormField>
    </div>
  );
};

export const DepartureTimeField = memo(forwardRef(Component));
